export default "__VITE_ASSET__CpluDz5z__"